import React from "react";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";

function Viewsql(props) {
    const {viewData} = props
  return (
    <>
      <div className="sql">
        {/* <div className="title">取数Sql</div> */}
        <div className="content">
          <Markdown
            data={{
              think: null,
              thinking: false,
              content: viewData,
            }}
          ></Markdown>
        </div>
      </div>
    </>
  );
}

export default Viewsql;
